import { EReviewEntityType, EReviewStatus } from 'models/review'

export const reviewStatusLabels: Record<EReviewStatus, string> = {
  [EReviewStatus.PENDING]: 'На модерации',
  [EReviewStatus.PUBLISHED]: 'Опубликован',
  [EReviewStatus.REJECTED]: 'Отклонён'
}

export const reviewStatusColors: Record<EReviewStatus, string> = {
  [EReviewStatus.PENDING]: 'blue',
  [EReviewStatus.PUBLISHED]: 'green',
  [EReviewStatus.REJECTED]: 'red'
}

export const reviewEntityTypeLabels: Record<EReviewEntityType, string> = {
  [EReviewEntityType.PRODUCT]: 'Товар',
  [EReviewEntityType.HORSE]: 'Лошадь',
  [EReviewEntityType.SERVICE]: 'Услуга'
}

export const getReviewStatusLabel = (status: string) => {
  return reviewStatusLabels[status as EReviewStatus] ?? status
}

export const getReviewStatusColor = (status: string) => {
  return reviewStatusColors[status as EReviewStatus] ?? 'default'
}

export const getReviewEntityTypeLabel = (type: string) => {
  return reviewEntityTypeLabels[type as EReviewEntityType] ?? type
}
